<nav
  aria-label="Fußzeile"
  >
  <ul class="footer-links" fxLayout="row wrap" fxLayoutGap="40px" fxLayoutAlign="center center">
    @if (mode == 'portal') {
      <li><a routerLink="misc/imprint">{{ 'portal.footer.imprint' | translate }}</a></li>
    }
    @if (mode == 'portal') {
      <li><a routerLink="misc/termsofuse">{{ 'portal.footer.termsOfUse' | translate }}</a></li>
    }
    @if (mode == 'portal') {
      <li><a routerLink="misc/privacypolicy">{{ 'portal.footer.privacyPolicy.title' | translate }}</a></li>
    }
    @if (mode == 'portal') {
      <li><a routerLink="misc/accessibility">{{ 'portal.footer.accessibility.title' | translate }}</a></li>
    }
    @if (mode == 'portal') {
      <li><a routerLink="misc/contact">{{ 'portal.footer.contact' | translate }}</a></li>
    }
    @if (mode == 'portal') {
      <li><a routerLink="misc/cookielist">{{ 'portal.footer.cookielist.title' | translate }}</a></li>
    }
    @if (mode == 'portal') {
      <li><a routerLink="misc/faq">{{ 'portal.footer.faq.title' | translate }}</a></li>
    }
    @if (mode == 'app') {
      @if (mode == 'app') {
        <li><a routerLink="misc/appimprint">{{ 'portal.footer.imprint' | translate }}</a></li>
      }
      @if (mode == 'app') {
        <li><a routerLink="misc/appprivacypolicy">{{ 'portal.footer.privacyPolicy.title' | translate }}</a></li>
      }
    }
  </ul>
</nav>